import React from 'react'
import { ConfirmDialog } from '../confirmDialog/ConfirmDialog'

// Confirmacao do Remover nas telas de parametros da empresa e da unidade (PHOENIX-959): cita a chave selecionada,
// porque credencial mascarada nao pode ser redigitada de memoria depois de removida.
export const ConfirmarRemocaoParametro = ({ visible, chave, texto, confirm, hideDialog }) => {
  if (!visible || !chave) {
    return null
  }
  return (
    <ConfirmDialog
      visible={visible}
      content={
        <span>
          {texto} <b>{chave}</b>
        </span>
      }
      confirm={confirm}
      hideDialog={hideDialog}
    />
  )
}
